import { call, put } from 'redux-saga/effects';
import _ from 'lodash';

import { firestore, getTenantPath } from '../utils/firebase';

function update(path, obj) {
  return firestore.doc(path)
    .update(obj)
    .then(() => obj);
}

function updateSaga(routine, pathExtractor, valueExtractor = (obj) => obj) {
  function* result(action) {
    const payload = action.payload;
    try {
      // trigger request action
      yield put(routine.request(payload));
      // perform request to '/some_url' to fetch some data
      const response = yield call((obj) => update(pathExtractor(obj), valueExtractor(obj)), payload);
      // if request successfully finished
      yield put(routine.success({ success: true, request: action.payload, response }));
    } catch (err) {
      console.error(err);
      // if request failed
      yield put(routine.failure({ success: false, request: action.payload }));
    } finally {
      // trigger fulfill action
      yield put(routine.fulfill());
    }
  }

  return result;
}

function updateCol(path, obj) {
  const batch = firestore.batch();

  _.keys(obj).forEach((id) => {
    batch.update(firestore.doc(`${path}/${id}`), obj[id]);
  });

  return batch.commit();
}

function updateColSaga(routine, pathExtractor, valueExtractor = (obj) => obj) {
  function* result(action) {
    const payload = action.payload;
    try {
      // trigger request action
      yield put(routine.request(payload));
      // perform request to '/some_url' to fetch some data
      const response = yield call((obj) => updateCol(pathExtractor(obj), valueExtractor(obj)), payload);
      // if request successfully finished
      yield put(routine.success({ success: true, request: action.payload, response }));
    } catch (err) {
      console.error(err);
      // if request failed
      yield put(routine.failure({ success: false, request: action.payload }));
    } finally {
      // trigger fulfill action
      yield put(routine.fulfill());
    }
  }

  return result;
}

function set(path, obj, merge = true) {
  console.log('update', path, obj);
  return firestore.doc(path)
    .set(obj, { merge })
    .then(() => obj);
}

function setSaga(routine, pathExtractor, valueExtractor = (obj) => obj, merge) {
  function* result(action) {
    const payload = action.payload;
    try {
      // trigger request action
      yield put(routine.request(payload));
      // perform request to '/some_url' to fetch some data
      const response = yield call((obj) => set(pathExtractor(obj), valueExtractor(obj), merge), payload);
      // if request successfully finished
      yield put(routine.success({ success: true, request: action.payload, response }));
    } catch (err) {
      console.error(err);
      // if request failed
      yield put(routine.failure({ success: false, request: action.payload }));
    } finally {
      // trigger fulfill action
      yield put(routine.fulfill());
    }
  }

  return result;
}

function fetchDoc(path, enrich = (obj) => obj) {
  const ref = firestore.doc(path);
  return ref.get().then((snap) => snap.exists ? snap.data() : null).then(enrich);
}

function fetchDocSaga(routine, pathExtractor, enrich = (obj) => obj) {
  function* result(action) {
    try {
      // trigger request action
      yield put(routine.request(action.payload));
      // perform request to '/some_url' to fetch some data
      const response = yield call((obj) => fetchDoc(pathExtractor(action.payload), enrich));
      // if request successfully finished
      yield put(routine.success({ success: true, request: action.payload, response }));
    } catch (err) {
      console.error(err);
      // if request failed
      yield put(routine.failure({ success: false, request: action.payload }));
    } finally {
      // trigger fulfill action
      yield put(routine.fulfill());
    }
  }

  return result;
}

function fetchCol(path, enrich = (obj) => obj) {
  const ref = firestore.collection(path);
  return ref.get().then((snap) => {
    const docs = {};
    snap.forEach(doc => {
      docs[doc.id] = _.assign(enrich(doc.data()), { id: doc.id });
    });
    return docs;
  });
}

function fetchColSaga(routine, pathExtractor, enrich = (obj) => obj) {
  function* result(action) {
    try {
      // trigger request action
      yield put(routine.request(action.payload));
      // perform request to '/some_url' to fetch some data
      const response = yield call((obj) => fetchCol(pathExtractor(action.payload), enrich));
      // if request successfully finished
      yield put(routine.success({ success: true, request: action.payload, response }));
    } catch (err) {
      console.error(err);
      // if request failed
      yield put(routine.failure({ success: false, request: action.payload }));
    } finally {
      // trigger fulfill action
      yield put(routine.fulfill());
    }
  }

  return result;
}

function remove(path) {
  console.log('remove', path);
  return firestore.doc(path)
    .remove();
}

function removeSaga(routine, pathExtractor) {
  function* result(action) {
    const payload = action.payload;
    try {
      // trigger request action
      yield put(routine.request(payload));
      // perform request to '/some_url' to fetch some data
      yield call((obj) => remove(pathExtractor(obj)));
      // if request successfully finished
      yield put(routine.success({ success: true, request: action.payload }));
    } catch (err) {
      console.error(err);
      // if request failed
      yield put(routine.failure({ success: false, request: action.payload }));
    } finally {
      // trigger fulfill action
      yield put(routine.fulfill());
    }
  }

  return result;
}

export {
  getTenantPath,
  update,
  updateSaga,
  updateCol,
  updateColSaga,
  set,
  setSaga,
  fetchDoc,
  fetchDocSaga,
  fetchCol,
  fetchColSaga,
  removeSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/helper.js